import { useState, useEffect, useCallback } from "react";

const USERNAME_STORAGE_KEY = "fst_chat_username";
const DEFAULT_USERNAME = "anon";

export function useUsername(): [string, (newUsername: string) => void] {
  const [username, setUsernameState] = useState<string>(() => {
    // Initialize state from localStorage or default
    try {
      const storedUsername = localStorage.getItem(USERNAME_STORAGE_KEY);
      return storedUsername ? storedUsername.trim() : DEFAULT_USERNAME;
    } catch (error) {
      console.error("Error reading username from localStorage:", error);
      return DEFAULT_USERNAME;
    }
  });

  // Update localStorage whenever username state changes
  useEffect(() => {
    try {
      if (username.trim()) {
        localStorage.setItem(USERNAME_STORAGE_KEY, username.trim());
      } else {
        // If user tries to set an empty username, reset to default
        localStorage.setItem(USERNAME_STORAGE_KEY, DEFAULT_USERNAME);
        setUsernameState(DEFAULT_USERNAME); // Also update state
      }
    } catch (error) {
      console.error("Error saving username to localStorage:", error);
    }
  }, [username]);

  // Function to update the username (ensures trimming)
  const setUsername = useCallback((newUsername: string) => {
    const trimmedUsername = newUsername.trim();
    setUsernameState(trimmedUsername || DEFAULT_USERNAME); // Use default if empty after trim
  }, []);

  return [username, setUsername];
}
